/**
 * Vocabulario del catálogo: tiers de seguridad y su lectura en pantalla.
 *
 * Los cuatro valores son los de `services/api/schemas/catalog.py::SecurityTier`,
 * que a su vez son los de `services/worker/rules/context.py`. No es una lista
 * cosmética: un producto con un tier fuera de esta lista hace que la regla de
 * reuso de código caiga al default y deje de calibrar para ese producto.
 */
import type { MessageKey } from '@/i18n/messages';
import type { Tone } from '@/ui/Badge';

export const SECURITY_TIERS = ['qr_only', 'qr_scratch', 'qr_nfc', 'nfc'] as const;

export type SecurityTier = (typeof SECURITY_TIERS)[number];

export const TIER_LABEL_KEYS: Record<SecurityTier, MessageKey> = {
  qr_only: 'products.tier.qr_only',
  qr_scratch: 'products.tier.qr_scratch',
  qr_nfc: 'products.tier.qr_nfc',
  nfc: 'products.tier.nfc',
};

export function isSecurityTier(value: string): value is SecurityTier {
  return (SECURITY_TIERS as readonly string[]).includes(value);
}

/**
 * El tier no es un estado de riesgo, así que va en neutro. El color en este
 * dashboard significa "alguien tiene que actuar"; pintar de verde el tier más
 * alto convertiría una decisión comercial en una señal de seguridad.
 */
export const TIER_TONE: Tone = 'neutral';

/**
 * `risk_score` viene 0..100 del motor de anomalías. Los cortes son los que usa
 * la bandeja: por debajo de 40 no hay nada que mirar.
 */
export function riskTone(score: number): Tone {
  if (score >= 70) return 'critical';
  if (score >= 40) return 'suspect';
  return 'neutral';
}
